import PageComponent from '../base/PageComponent';

export default class GlobalContent extends PageComponent {
    init() {

        this.ready();
    }

    ready(){
        $(".scroll-bottom").click(function (e) {
            window.scrollTo(0,document.body.scrollHeight);
        });

        window.Parsley.on('form:error', function () {
            var ele = $(".parsley-required").first();
            window.scrollTo(0,ele.offset().top - 100);
        });
    }
}